'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const className = classnames(
  'flex',
  'flex-row',
  'background-input-background-color',
  'border',
  'border-input-border-color',
  'rounded',
  'p-2',
  'gap-2'
);

const makeTestId = (id?: string) => ['toggle', id].filter((i) => !!i).join('-');

const makeChildrenClassName = (disabled: boolean) =>
  classnames({
    'text-sm': true,
    'leading-normal': true,
    'text-input-icon-disabled-color': disabled,
  });

const makeIconClassName = (disabled: boolean) =>
  classnames({
    flex: true,
    'items-center': true,
    'cursor-pointer': true,
    'text-input-icon-disabled-color': disabled,
    'text-input-icon-color': !disabled,
  });

interface Props {
  children: ReactNode;
  disabled?: boolean;
  icon?: Icon;
  onClick?: () => void;
  id?: string;
}

const Toggle = ({
  children,
  disabled = false,
  icon,
  onClick,
  id = undefined,
}: Props) => (
  <div className={className}>
    <div
      onClick={() => {
        if (!disabled) onClick?.();
      }}
      className={makeIconClassName(disabled)}
      data-testid={makeTestId(id)}
    >
      <IconView size="lg" icon={icon} />
    </div>
    <div className={makeChildrenClassName(disabled)}>{children}</div>
  </div>
);

export default Toggle;
